import { reactive, getCurrentInstance, computed } from 'vue';
export const useBUPlanWithdrawCashDetailData = () => {
  const { proxy } = getCurrentInstance();

  /**
   * Biến dùng để disabled Sinh chứng từ chuyển khoản KB vào TK tiền gửi
   * NXCHIEN 26.04.2022
   */
  const valueMode = computed(() => {
    return proxy.editMode != proxy.$ms.constant.FormState.View;
  });

  /**
   * Biến dùng để disabled Sinh chứng từ ngược lại
   * NXCHIEN 26.04.2022
   */
  const genData = computed(() => {
    return proxy._formParam?.data?.IsGenerateData || proxy.editMode != proxy.$ms.constant.FormState.View;
  });

  // item của button tiện ích
  const buttonUtilities = reactive([
    {
      text: 'Thêm chứng từ',
      command: 'Add',
      disabledItem: valueMode,
      IsSubMenu: true,
      icon: 'right-arrow-grey',
      subItem: [
        {
          text: 'Rút dự toán tiền mặt',
          command: 'ShowWithDrawCash',
        },
        {
          text: 'Rút dự toán tiền gửi',
          command: 'ShowWithDrawDeposit',
        },
        {
          text: 'Rút dự toán chuyển khoản',
          command: 'ShowWithDrawTransfer',
        },
        {
          text: 'Rút dự toán chuyển khoản lương, bảo hiểm',
          command: 'ShowWithDrawSalaryTransfer',
        },
      ],
    },
    {
      text: 'Thêm mới từ chứng từ hiện thời',
      command: 'Duplicate',
      disabledItem: valueMode,
      IsSubMenu: true,
      icon: 'right-arrow-grey',
      subItem: [
        {
          text: 'Rút dự toán tiền mặt',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BUPlanWithdrawCashDetail',
          refType: proxy.$ms.constant.RefType.BUPlanWithdrawCash,
          initial: true
        },
        {
          text: 'Rút dự toán tiền gửi',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BUPlanWithdrawDepositDetail',
          refType: proxy.$ms.constant.RefType.BUPlanWithdrawDeposit,
        },
        {
          text: 'Rút dự toán chuyển khoản',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BUPlanWithdrawTransferDetail',
          refType: proxy.$ms.constant.RefType.BUPlanWithdrawTransfer
        },
        {
          text: 'Rút dự toán chuyển khoản lương, bảo hiểm',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BUPlanWithdrawSalaryTransferDetail',
          refType: proxy.$ms.constant.RefType.BUPlanWithdrawSalaryTransfer
        },
      ]
    },
    // {
    //   text: 'Xóa chứng từ hiện thời',
    //   command: 'Delete',
    //   disabledItem: valueMode,
    // },
    {
      text: 'Sinh phiếu thu',
      command: 'ShowCAReceipt',
      disabledItem: genData,
    },
  ]);

  return {
    buttonUtilities,
    valueMode,
  };
};
